module.exports = __webpack_public_path__ + "assets/img/6_676.51b41df2.jpg";